import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { minBreakpoints } from 'client-ribbons-base/constants/breakpoints';

const sizes = {
  font32: {
    fontSize: 32,
    lineHeight: 48,
  },
  font30: {
    fontSize: 30,
    lineHeight: 45,
  },
  font28: {
    fontSize: 28,
    lineHeight: 42,
  },
  font26: {
    fontSize: 26,
    lineHeight: 39,
  },
  font24: {
    fontSize: 24,
    lineHeight: 36,
  },
  font22: {
    fontSize: 22,
    lineHeight: 33,
  },
  font20: {
    fontSize: 20,
    lineHeight: 30,
  },
  font18: {
    fontSize: 18,
    lineHeight: 27,
  },
  font16: {
    fontSize: 16,
    lineHeight: 24,
  },
  font14: {
    fontSize: 14,
    lineHeight: 21,
  },
  font12: {
    fontSize: 12,
    lineHeight: 18,
  },
  font10: {
    fontSize: 10,
    lineHeight: 15,
  },
};

export const responsiveHeadingXL = css`
  font-size: ${pxToRem(sizes.font28.fontSize)};
  line-height: ${pxToRem(sizes.font28.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      font-size: ${pxToRem(sizes.font30.fontSize)};
      line-height: ${pxToRem(sizes.font30.lineHeight)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font32.fontSize)};
      line-height: ${pxToRem(sizes.font32.lineHeight)};
    `,
  )};
`;

export const responsiveHeadingLG = css`
  font-size: ${pxToRem(sizes.font24.fontSize)};
  line-height: ${pxToRem(sizes.font24.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      font-size: ${pxToRem(sizes.font26.fontSize)};
      line-height: ${pxToRem(sizes.font26.lineHeight)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font28.fontSize)};
      line-height: ${pxToRem(sizes.font28.lineHeight)};
    `,
  )};
`;

export const responsiveHeadingMD = css`
  font-size: ${pxToRem(sizes.font20.fontSize)};
  line-height: ${pxToRem(sizes.font20.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      font-size: ${pxToRem(sizes.font22.fontSize)};
      line-height: ${pxToRem(sizes.font22.lineHeight)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font24.fontSize)};
      line-height: ${pxToRem(sizes.font24.lineHeight)};
    `,
  )};
`;

export const responsiveHeadingSM = css`
  font-size: ${pxToRem(sizes.font18.fontSize)};
  line-height: ${pxToRem(sizes.font18.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font20.fontSize)};
      line-height: ${pxToRem(sizes.font20.lineHeight)};
    `,
  )};
`;

export const responsiveHeadingXS = css`
  font-size: ${pxToRem(sizes.font16.fontSize)};
  line-height: ${pxToRem(sizes.font16.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font18.fontSize)};
      line-height: ${pxToRem(sizes.font18.lineHeight)};
    `,
  )};
`;

export const responsiveBodyMD = css`
  font-size: ${pxToRem(sizes.font14.fontSize)};
  line-height: ${pxToRem(sizes.font14.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font16.fontSize)};
      line-height: ${pxToRem(sizes.font16.lineHeight)};
    `,
  )};
`;

export const responsiveBodySM = css`
  font-size: ${pxToRem(sizes.font12.fontSize)};
  line-height: ${pxToRem(sizes.font12.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font14.fontSize)};
      line-height: ${pxToRem(sizes.font14.lineHeight)};
    `,
  )};
`;

export const responsiveBodyXS = css`
  font-size: ${pxToRem(sizes.font10.fontSize)};
  line-height: ${pxToRem(sizes.font10.lineHeight)};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      font-size: ${pxToRem(sizes.font12.fontSize)};
      line-height: ${pxToRem(sizes.font12.lineHeight)};
    `,
  )};
`;
